import type { IntlShape } from 'react-intl';
import type { Portal } from '@immo/api-contract';

// Brand names are not translated; `Record<Portal, …>` makes the map total at compile time.
export const PORTAL_NAMES: Record<Portal, string> = {
  IMMOSCOUT24: 'ImmoScout24',
  KLEINANZEIGEN: 'Kleinanzeigen',
  IMMOWELT: 'Immowelt',
};

export const NO_PORTALS: ReadonlyArray<Portal> = [];

/** „ImmoScout24 und Kleinanzeigen" — one rendering of a portal list for every sentence that names them. */
export const formatPortalNames = (intl: IntlShape, portals: ReadonlyArray<Portal>): string =>
  intl.formatList(
    portals.map((portal) => PORTAL_NAMES[portal]),
    { type: 'conjunction' },
  );
